import { FunctionComponent } from 'react';

import Button, {    ButtonElements,
    ButtonLayouts,    ButtonSizes,
    ButtonStyles,
    ButtonTypes,
    ButtonVariants } from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';
import Slick from 'components/layout/Slick';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionInfo: FunctionComponent<Props> = ({
    translations: {
        title,
        box1,
        box2,
        box3,
        box4,
    },
}) => {
    const settings = {
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
    };

    return (
        <StyledComponent className="public-page-about-section-info">
            <LayoutContainer>
                <div
                    className="title-section"
                    dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="section-container">
                    <div className="cols">
                        <div className="col-text left">
                            <div
                                className="title"
                                dangerouslySetInnerHTML={{ __html: box1.title }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box1.description1 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box1.description2 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box1.description3 }}
                            />
                            <Button
                                type={ButtonTypes.Button}
                                element={ButtonElements.Anchor}
                                href={box1.buttonHref}
                                size={ButtonSizes.Medium}
                                style={ButtonStyles.Primary}
                                variant={ButtonVariants.Primary}
                                layout={ButtonLayouts.Wide}
                            >
                                {box1.buttonLabel}
                            </Button>
                        </div>

                        <div className="col-image right image-right">
                            <img
                                src={box1.imageUrl}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>

                <div className="section-container">
                    <div className="cols reverse">
                        <div className="col-image left image-left">
                            <img
                                src={box2.imageUrl}
                                loading="lazy"
                            />
                        </div>
                        <div className="col-text right left-list">
                            <div
                                className="title"
                                dangerouslySetInnerHTML={{ __html: box2.title }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box2.description1 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box2.description2 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box2.description3 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box2.description4 }}
                            />
                            <div className="button-wrapper">
                                <Button
                                    type={ButtonTypes.Button}
                                    element={ButtonElements.Anchor}
                                    href={box2.buttonLeftHref}
                                    size={ButtonSizes.Medium}
                                    style={ButtonStyles.Primary}
                                    variant={ButtonVariants.Primary}
                                    layout={ButtonLayouts.Wide}
                                >
                                    {box2.buttonLeftLabel}
                                </Button>
                                <Button
                                    type={ButtonTypes.Button}
                                    element={ButtonElements.Anchor}
                                    href={box2.buttonRightHref}
                                    size={ButtonSizes.Medium}
                                    style={ButtonStyles.Secondary}
                                    variant={ButtonVariants.Primary}
                                    layout={ButtonLayouts.Wide}
                                >
                                    {box2.buttonRightLabel}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section-container">
                    <div className="cols">
                        <div className="col-text left">
                            <div
                                className="title"
                                dangerouslySetInnerHTML={{ __html: box3.title }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box3.description1 }}
                            />
                            <div
                                className="description image-description"
                                dangerouslySetInnerHTML={{ __html: box3.description2 }}
                            />
                            <div className="button-wrapper">
                                <div className="control">
                                    <div
                                        className="button-title"
                                        dangerouslySetInnerHTML={{ __html: box3.buttonLeftTitle }}
                                    />
                                    <Button
                                        type={ButtonTypes.Button}
                                        element={ButtonElements.Anchor}
                                        href={box3.buttonLeftHref}
                                        size={ButtonSizes.Medium}
                                        style={ButtonStyles.Primary}
                                        variant={ButtonVariants.Primary}
                                        layout={ButtonLayouts.Block}
                                    >
                                        {box3.buttonLeftLabel}
                                    </Button>
                                </div>
                                <div className="control">
                                    <div
                                        className="button-title"
                                        dangerouslySetInnerHTML={{ __html: box3.buttonRightTitle }}
                                    />
                                    <Button
                                        type={ButtonTypes.Button}
                                        element={ButtonElements.Anchor}
                                        href={box3.buttonRightHref}
                                        size={ButtonSizes.Medium}
                                        style={ButtonStyles.Secondary}
                                        variant={ButtonVariants.Primary}
                                        layout={ButtonLayouts.Block}
                                    >
                                        {box3.buttonRightLabel}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="col-image right image-right">
                            <img
                                src={box3.imageUrl}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </LayoutContainer>

            <div
                className="section-container"
                style={{ backgroundImage: `url(${box4.backgroundUrl})` }}
            >
                <LayoutContainer>
                    <div className="cols">
                        <div className="col-image left image-left mobile-image">
                            <img
                                src={box4.imageUrl}
                                loading="lazy"
                            />
                        </div>
                        <div className="about-slick">
                            <img
                                className="img-top"
                                src="/images/about/podkreslenie_y.svg"
                                loading="lazy"
                            />
                            <Slick sliderProps={settings}>
                                {box4.slickImages.map(element => (
                                    <div
                                        className="img-box"
                                        key={element.about}
                                    >
                                        <img
                                            src={element.about}
                                            loading="lazy"
                                        />
                                    </div>
                                ))}
                            </Slick>
                        </div>
                        <div className="col-text left">
                            <div
                                className="title"
                                dangerouslySetInnerHTML={{ __html: box4.title }}
                            />
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: box4.subtitle }}
                            />
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: box4.description }}
                            />
                        </div>
                    </div>
                </LayoutContainer>
            </div>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionInfo;